jQuery(document).ready(function ($) {
  //Homepage / benefits section functionality
  $(".benefit-switch").on("change", function (e) {
    //details enable/disable functionality
    var enabled_checkboxes = [];

    $(".benefit-switch").each(function () {
      if ($(this).is(":checked")) {
        enabled_checkboxes.push($(this).data("benefit-id"));
      }
    });

    var i;
    var tips_enabled = [];
    for (i = 0; i < enabled_checkboxes.length; ++i) {
      $(".benefits-list-info li").each(function () {
        var list_array = $(this).data("benefits-list").toString().split(",");
        /*console.log(
					list_array +
						" - " +
						enabled_checkboxes[i].toString() +
						" | " +
						$(this).index()
				);*/
        if (list_array.includes(enabled_checkboxes[i].toString())) {
          tips_enabled.push($(this).index());
        }
      });
    }
    $(".benefits-list-info li").addClass("faded");
    for (i = 0; i < tips_enabled.length; ++i) {
      $(".benefits-list-info li").eq(tips_enabled[i]).removeClass("faded");
    }

    //dots enable/disable
    if ($(this).is(":checked")) {
      $('*[data-bid="' + $(this).data("benefit-id") + '"]').addClass(
        "dot-enabled"
      );
    } else {
      $('*[data-bid="' + $(this).data("benefit-id") + '"]').removeClass(
        "dot-enabled"
      );
    }

    return false;
  });

  //Footer mobile toggles
  $(".footer-toggle-btn").on("click", function (e) {
    e.preventDefault();

    if ($(window).width() < 768) {
			$(this).parents(".footer-widget").toggleClass("footer-widget-open");
			$(this).next('.footer-widget-content').slideToggle();
    }
  });

  //Mobile btn trigger side filters
  $(".btn-trigger-side-filters, .btn-close-sidebar-filters").on(
    "click",
    function (e) {
      e.preventDefault();

      $(".shop-column-sidebar").toggleClass("active");
    }
  );

  $(".scrollto").on("click", function (e) {
    e.preventDefault();

    var $target = $($.attr(this, "href"));
    if ($target.length > 0) {
      $("html, body").animate(
        {
          scrollTop: $target.offset().top,
        },
        500
      );
    }
  });

  //Prevent jumping on social share button click
    $(".social-share__button").on("click", function (e) {
        e.preventDefault();
    });

  $(".jsTestimonialsSliderWrapper").each(function () {
    var $wrapper = $(this);
    var $slider = $wrapper.find(".jsTestimonialsSlider");
    var $nav = $wrapper.find(".jsTestimonialsCarouselNav");
    var $dot = $wrapper.find(".jsTestimonialsCarouselDot");

    $slider.owlCarousel({
      items: 1,
      slideBy: 1,
      nav: false,
      dots: false,
      autoplay: true,
    });

    $slider.on("changed.owl.carousel", function (e) {
      $nav.find(".jsTestimonialsCarouselDot").removeClass("is_active");
      $nav
        .find(".jsTestimonialsCarouselDot")
        .eq(e.item.index)
        .addClass("is_active");
    });

    $dot.on("click", function (e) {
      e.preventDefault();

      if (!$(this).hasClass("is_active")) {
        $slider.trigger("to.owl.carousel", $(this).index());
        $(this)
          .parent()
          .find(".jsTestimonialsCarouselDot")
          .removeClass("is_active");
        $(this).addClass("is_active");
      }
    });
  });

  $(".jsGalleryCarouselSliderWrapper").each(function () {
    var $wrapper = $(this);
    var $slider = $wrapper.find(".jsGalleryCarouselSlider");
    var $position = $wrapper.find(".jsGalleryCarouselPotitionTarget");
    var $caption = $wrapper.find(".jsGalleryCarouselCaption");
    var $nav = $wrapper.find(".jsGalleryCarouselNav");

    $slider.owlCarousel({
      items: 1,
      slideBy: 1,
      nav: false,
      dots: false,
      loop: true,
      margin: 40,
    });

    $slider.on("changed.owl.carousel", function (e) {
      var slides = e.relatedTarget;
      var index = slides.relative(slides.current()) + 1;

      $position.text(index > 9 ? index : "0" + index);

      $caption.text(
        $wrapper
          .find(".owl-item:not(.cloned)")
          .eq(index - 1)
          .find(".jsGalleryCarouselSlide")
          .data("caption")
      );
    });

    $nav.find("[data-dir]").on("click", function (e) {
      e.preventDefault();

      $slider.trigger($(this).data("dir") + ".owl.carousel");
    });
  });

    $(".js-product-tab").each(function () {
        var $wrapper = $(this);
        var $slider = $wrapper.find(".products");
        var $nav = $wrapper.find(".js-carousel-nav");

        $slider.addClass( 'owl-carousel' );

        $slider.owlCarousel({
            items: 1,
            slideBy: 1,
            nav: false,
            dots: false,
            loop: false,
            margin: 40,
            responsive:{
                0:{
                    items:1,
                },
                600:{
                    items:2,
                },
                900:{
                    items:3,
                },
                1400:{
                    items:4,
                }
            }
        });

        $nav.find("[data-dir]").on("click", function (e) {
            e.preventDefault();

            $slider.trigger($(this).data("dir") + ".owl.carousel");
        });
    });


  $(".jsAccordionWrapper").each(function () {
    var $accordion = $(this);

    $accordion.find(".jsAccordionItemHeader").on("click", function (e) {
      e.preventDefault();

      var $item = $(e.target).parent().closest(".jsAccordionItem");
      var $title = $item.find(".jsAccordionItemTitle");
      var $toggler = $item.find(".jsAccordionItemToggler");
      var $body = $item.find(".jsAccordionItemBody");

      if (!$title.hasClass('is_active')) {
        $accordion.find(".jsAccordionItemTitle").removeClass("is_active");
        $accordion.find(".jsAccordionItemToggler").removeClass("is_active");
        $accordion.find(".jsAccordionItemBody").slideUp();
        $title.addClass("is_active");
        $toggler.addClass("is_active");
        $body.slideDown();
      } else {
        $title.removeClass("is_active");
        $toggler.removeClass("is_active");
        $body.slideUp();
      }
		});

  });

	$('.jsFloatSearchButton').on('click', function(e) {
		e.preventDefault();

		var $form = $(this).parent().find('form');

		if ( $form.hasClass('is_active') ) {
			$form.submit();
		} else {
			$form.addClass('is_active');
			setTimeout( closeSearchOnBodyClick , 500);
		}
	});

	function closeSearchOnBodyClick() {
    $('body').bind('click.search' , function(e){
      if( $(e.target).parents('.btn-search').length == 1 || e.target.id == 'jsFloatSearchButton') {
        return true;
      } else {
        $('.jsFloatSearchButton').parent().find('form').removeClass('is_active');
        $('body').unbind('click.search');
      }
    });
	}

	$('.offcanvas-menu').each(function() {

		var $menu = $(this);

		$menu.find('.menu-item-has-children > a').each(function() {

			$(this).addClass('jsOffcanvasMenuLink').append(
				$('<span/>', { class: 'offcanvas-menu-item__toggler' })
			);

		});

		$menu.find('.sub-menu').each(function() {

			var label = $(this).parent().children('a').eq(0).text();

			$(this).addClass('offcanvas-submenu__list');
			$(this).wrap('<div class="offcanvas-submenu jsOffcanvasSubmenu"></div>')
						 .prepend('<div class="offcanvas-submenu__label">' + label + '</div>');

		});

	});

	$('body').on('click', '.jsOffcanvasMenuLink', function(e) {
		e.preventDefault();

		$(this).parent().children('.jsOffcanvasSubmenu').addClass('is_active');
		$('.jsOffcanvasContentBtnBack').addClass('is_active');
	});

	$('.jsOffcanvasContentBtnBack').on('click', function(e) {
		e.preventDefault();

		$(this).removeClass('is_active');
		$(this).parent()
					 .closest('.offcanvas-content')
					 .find('.jsOffcanvasSubmenu')
					 .removeClass('is_active');

	});

	$('.jsOffcanvasContentBtnClose').on('click', function(e) {
		e.preventDefault();

		$(this).parent().closest('.jsOffcanvasContent').removeClass('is_active');
		$(this).parent().closest('.jsOffcanvasContent').find('.jsOffcanvasSubmenu').removeClass('is_active');
		$(this).parent().closest('.jsOffcanvasContent').find('.jsOffcanvasContentBtnBack').removeClass('is_active');
	});

	$('.jsHeaderMenuToggler').on('click', function(e) {
		e.preventDefault();

		$('.jsOffcanvasContent').addClass('is_active');
	});

	$('.jsGoogleTranslateSelectorCaption').on('click', function(e) {
		e.preventDefault();

		const popup = $(this).parents('.header-google-translate').find('.gtranslate_wrapper')[0];
		const backdrop = $(this).parents('.header-google-translate').find('.gt_black_overlay')[0];

		/* copied / pasted from the plugin file */
		var gt_popup_open = false;

    function gt_show_popup(el) {
        gt_popup_open = true;
        el.parentNode.querySelectorAll('.gt_white_content a img:not([src])').forEach(function(img) {img.setAttribute('src', img.getAttribute('data-gt-lazy-src'));});
        el.parentNode.querySelectorAll('.gt_white_content,.gt_black_overlay').forEach(function(e){e.style.display='block';});
    }

    function gt_hide_popup() {gt_popup_open=false;document.querySelectorAll('.gt_white_content,.gt_black_overlay').forEach(function(e){e.style.display='none'});}
		/* end copy paste */

		gt_show_popup(popup);

    backdrop.addEventListener('click', function(evt) {
			if(gt_popup_open) gt_hide_popup();
		});
	});

  /* ==========================================================================
	   FaceWP cookies
	   ========================================================================== */
  // /**
	//  * After FacetWP reloads, store any updates into a cookie
	//  */
  // $(document).on("facetwp-loaded", function () {
  //   if (document.location.href.indexOf("shop") === -1) return;
  //
  //   var date = new Date();
  //   var facets = window.location.search;
  //   date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
  //   document.cookie =
  //     "facetdata=" + facets + "; expires=" + date.toGMTString() + "; path=/";
  // });
  //
  // /**
	//  * When FacetWP first initializes, look for the "facetdata" cookie
	//  * If it exists, set window.location.search= facetdata
	// */
  // $(document).on("facetwp-refresh", function () {
  //   if (document.location.href.indexOf("shop") === -1) return;
  //
  //   if (!FWP.loaded) {
  //     var facets = window.location.search;
  //     var facetdata = readCookie("facetdata");
  //     if (null != facetdata && "" != facetdata && facets != facetdata) {
  //       document.cookie =
  //         "facetdata=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
  //       window.location.search = facetdata;
  //     }
  //   }
	// });

	// /**
	//  * Automatically scroll to the top of the page upon pagination
	//  */
	// $(document).on('facetwp-loaded', function() {
	// 	if ( FWP.loaded && $('.facetwp-facet-pagination').length > 0 ) {
	// 		$('html, body').animate({
	// 			scrollTop: 0
	// 		}, 500);
	// 	}
	// });

	// Disable filters from populating until the previous is selected
	$('.facetwp-type-fselect').on('click', function(e) {

		var $form_el = $(this).parent();
		if ( $form_el.index() > 0 && $form_el.prev().find('.fs-wrap').hasClass('fs-default') ) {
			e.preventDefault();
			e.stopPropagation();
		}

	});

	$('.widget-part-vehicle-select .facetwp-type-fselect').on('click', function(e) {

		if ( $(this).index() > 0 && $(this).prev().prev().find('.fs-wrap').hasClass('fs-default') ) {
			e.preventDefault();
			e.stopPropagation();
		}

	});

	$('.subscribe-form').on('submit', function() {
		var interval = setInterval(function() {
			if ( $('.validation_error').length > 0 ) {
				$('.validation_error').css('margin-top', '40px').insertAfter($('.validation_error').parent());
				clearInterval(interval);
			}
		}, 10);
	});

	$('.product-single-more-btn').each(function() {

		$(this).prev().append( $(this) );

	});

    // Clear FacetWP filters on button click
    $('.btn-clear-filters').on('click', function(e) {
        FWP.reset();
    });

  /*
	Cookie handler
	*/
  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }



    // FacetWP - modify the HTML for facetwp_display( 'selections' )
    // reference: \wp-content\plugins\facetwp\assets\js\front.js - Generate the user selections
    if (jQuery('.products-archive-selections').length) {
        FWP.hooks.addAction('facetwp/loaded', function () {
            // add custom code here

            var selections = '<h1>';
            jQuery.each(FWP.facets, function (key, val) {
                if (val.length < 1 || 'undefined' === typeof FWP.settings.labels[key]) {
                    return true; // skip this facet
                }
                var choices = val;
                var facet_type = jQuery('.facetwp-facet-' + key).attr('data-type');
                choices = FWP.hooks.applyFilters('facetwp/selections/' + facet_type, choices, {
                    'el': jQuery('.facetwp-facet-' + key),
                    'selected_values': choices
                });

                if ('string' === typeof choices) {
                    choices = [{ value: '', label: choices }];
                }
                else if ('undefined' === typeof choices[0].label) {
                    choices = [{ value: '', label: choices[0] }];
                }
                var values = '';
                jQuery.each(choices, function (indx, choice) {
                    //ensure every selected facet item is wrapped around a data-facet-[key] li element to leave other functionality intact
                    selections += '<span data-facet="' + key + '"><span class="facetwp-selection-value" data-value="' + choice.value + '">' + choice.label + ' </span></span';
                });

            });

            selections += '</h1>';

            //console.log(selections);
            jQuery('.facetwp-selections').html(selections);

        }, 99); //using a higher number will ensure this custom function executes after facetwp's default selections html function.
    }
});

jQuery(window).on('load resize', function() {
    fixWooGalleryImageSize();

	jQuery('.jsFeaturedProductsList').each(function() {

		var $slider = jQuery(this);
		var $nav  	= jQuery(this).parent()
		  									 .closest('.jsFeaturedProductsListWrapper')
												 .find('.jsFeaturedProductsListNav');

		if ( window.matchMedia('(max-width: 767px)').matches ) {
			if ( !$slider.hasClass('owl-loaded') ) {

				$slider.owlCarousel({
					items: 1,
					dots: false,
					nav: false,
					stagePadding: 50,
					margin: 20,
					loop: true
				});

				$nav.find('a').on('click', function(e) {
					e.preventDefault();

					$slider.trigger(jQuery(this).data('dir') + '.owl.carousel');
				});

			}
		} else {
			if ( $slider.hasClass('owl-loaded') ) {
				$slider.trigger('destroy.owl.carousel');
			}
		}

	});

});

jQuery(window).on('load resize scroll', function() {

	repositionRelatedFadedTitle();

});

// If on product page, trigger resize so that fixWooGalleryImageSize() is triggered
jQuery(window).on('load', function() {
    if (jQuery('.single-product').length) {
        window.dispatchEvent(new Event('resize'));
    }
});

function repositionRelatedFadedTitle() {

	var diff = Math.abs(jQuery(window).outerWidth() - jQuery('.container').width()) / 2;

	jQuery('.related-faded-title').css({
		left: -diff + 'px'
	});

}

// Fix the woocommerce product gallery resize width/height issue
function fixWooGalleryImageSize() {
    jQuery('.woocommerce-product-gallery__image').height(
        jQuery('.woocommerce-product-gallery__image').width()
    );

    jQuery('.woocommerce-product-gallery .flex-viewport').height(
        jQuery('.woocommerce-product-gallery__image').height()
    );

    jQuery('.woocommerce-product-gallery__image').width(
        jQuery('.woocommerce-product-gallery .flex-viewport').width()
    );
}

function setupAudioEls() {
  const audioBlocks = [...document.querySelectorAll('.js-audio')];

  audioBlocks.forEach(audioBlock => {
    const audioPlayer = audioBlock.querySelector('.js-audio__player');
    const audioPlayButton = audioBlock.querySelector('.js-audio__play');
    const audioRestartButton = audioBlock.querySelector('.js-audio__restart');
    const audioTrack = audioBlock.querySelector('.js-audio__track');
    const audioProgress = audioBlock.querySelector('.js-audio__progress');

    audioPlayButton.addEventListener('click', (ev) => {
      ev.preventDefault();

      audioBlocks.forEach(block => {
        if (block === audioBlock) return;

        const otherPlayer = block.querySelector('.js-audio__player');
        otherPlayer.pause();
      });

      if (audioPlayer.paused) {
        audioPlayer.play();
        audioPlayButton.innerText = "Pause";
        audioPlayButton.classList.add('audio__play--paused');
      } else {
        audioPlayer.pause();
        audioPlayButton.innerText = "Play sound";
        audioPlayButton.classList.remove('audio__play--paused');
      }

      if (audioPlayer.currentTime === audioPlayer.duration) {
        audioPlayer.currentTime = 0;
      }
    });

    audioRestartButton.addEventListener('click', (ev) => {
      audioPlayer.currentTime = 0;
    });

    audioPlayer.addEventListener('timeupdate', () => {
      const percent = (audioPlayer.currentTime / audioPlayer.duration) * 100;
      audioProgress.style.width = `${percent}%`;
    });

    audioPlayer.addEventListener('ended', () => {
      audioPlayButton.classList.remove('audio__play--paused');
      audioPlayer.currentTime = 0;
    });

    audioTrack.addEventListener('click', (ev) => {
      const percent = ev.offsetX / audioTrack.offsetWidth;
      audioPlayer.currentTime = audioPlayer.duration * percent;
    });
  });
}

jQuery(document).on('ready', function() {
  if (jQuery('.js-audio').length) {
    setupAudioEls();
  }
});
